// extracted by mini-css-extract-plugin
export default {"dialog-paper":"share-profile-dialog_dialog-paper__QL-dE","dialog-content-root":"share-profile-dialog_dialog-content-root__nfS13"};